import Cookies from 'js-cookie'
/**
 * Created by Administrator on 2019/5/23.
 */
function store() {

}

store.get = function (key) {
   return Cookies.get(key);
    // return localStorage.getItem(key);
};

store.set = function (key, val) {
   return Cookies.set(key, val, { expires: 7 });
    // return localStorage.setItem(key, val);
}

store.delete = function (key) {
  return   Cookies.remove(key);
    // return localStorage.removeItem(key);
}

export default store;
